<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="acknowledgments">
<h1>Acknowledgments</h1>
<p>I want to acknowledge the support of Austin Macauley Publishers, who helped me to send my voice to people, mostly to youth, who are suffering from lacking new horizons in their today’s life.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch004.vue?4923aaa8